import { render, staticRenderFns } from "./BaseLocation.vue?vue&type=template&id=489c7fd4&scoped=true&"
import script from "./BaseLocation.vue?vue&type=script&lang=js&"
export * from "./BaseLocation.vue?vue&type=script&lang=js&"
import style0 from "./BaseLocation.vue?vue&type=style&index=0&id=489c7fd4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "489c7fd4",
  null
  
)

export default component.exports